import { RewardsPage } from '@/pages/rewards';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/rewards')({
	component: RewardsPage,
});
